import { useEffect, useState } from "react";

export default function MobileStickyCTA() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // Show after a short delay so it doesn't appear immediately on load (less intrusive)
    const t = setTimeout(() => setVisible(true), 1200);
    return () => clearTimeout(t);
  }, []);

  const scrollToForm = () => {
    const el =
      document.getElementById("presupuesto") ||
      document.getElementById("contacto") ||
      document.getElementById("formulario");
    if (el) {
      el.scrollIntoView({ behavior: "smooth", block: "start" });
    } else {
      window.scrollTo({ top: document.body.scrollHeight, behavior: "smooth" });
    }
  };

  if (!visible) return null;

  return (
    <div className="md:hidden fixed bottom-0 left-0 right-0 z-[9997] bg-white border-t border-border shadow-[0_-4px_20px_rgba(0,0,0,0.08)] safe-area-pb">
      <div className="flex items-center gap-2 px-3 py-2.5">
        {/* Primary CTA — Phone */}
        <a
          href="tel:+34951120770"
          className="flex-1 flex items-center justify-center gap-2 bg-primary hover:bg-primary-dark text-white font-body font-bold text-sm px-3 py-3 rounded-xl transition-colors touch-target"
          aria-label="Llamar al 951 12 07 70"
        >
          <i className="ri-phone-line text-lg" aria-hidden="true"></i>
          <span>951 12 07 70</span>
        </a>

        {/* WhatsApp */}
        <a
          href="https://wa.me/34627213347?text=Hola%2C%20me%20interesa%20info"
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center justify-center gap-1.5 bg-whatsapp hover:bg-[#128C7E] text-white font-body font-bold text-sm px-4 py-3 rounded-xl transition-colors touch-target"
          aria-label="Contactar por WhatsApp"
        >
          <i className="ri-whatsapp-line text-lg" aria-hidden="true"></i>
          <span className="hidden sm:inline">WhatsApp</span>
        </a>

        {/* Scroll to form */}
        <button
          onClick={scrollToForm}
          className="flex items-center justify-center gap-1.5 bg-surface-alt hover:bg-slate-200 border border-border text-text-primary font-body font-bold text-sm px-4 py-3 rounded-xl transition-colors touch-target"
          aria-label="Pedir presupuesto"
        >
          <i className="ri-file-list-3-line text-lg" aria-hidden="true"></i>
          <span className="hidden sm:inline">Presupuesto</span>
        </button>
      </div>
    </div>
  );
}